module.exports = __webpack_public_path__ + "img/qr_code.dec79f3c.png";